import { useEffect, useState } from 'react';
import { getdatanoauth, sendwhatsappmessageapi, WAITINGGIF } from '../../util/global';
import KitLoader from '../../components/kitsters/KitLoader';
import { useSearchSort } from '../../components/kitsters/useSearchSort';
import TableItem from "./TableItem"
import TableCompositeItem from "./TableCompositeItem"


const ItemStockCheck = () => {
  const [compositeitemdata, setcompositeitemdata] = useState<any[]>([]);
  const [itemdata, setitemdata] = useState(true);
  const [loading, setLoading] = useState(true);


  const fetchdata = async () => {
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');

    let data = await getdatanoauth({ zohodatatype: 'compositeitems', _adminuserid: adminuserid, zohoresponsekey: 'composite_items' }, '/zohodatanoauth');
    setcompositeitemdata(data.data);

    data = await getdatanoauth({ zohodatatype: 'items', _adminuserid: adminuserid, tag:"stockmismatch" }, '/zohodatanoauth');
    setitemdata(data.data);
    setLoading(false);
  };


  const sendwhatsappmessage = async () => {
    $(".sendstatus").html(" | sending " + WAITINGGIF);
    
    let receiverphonenumber =  [
      {name:"viraj", "phonenumber":"919623078401"},
      {name:"aditi", "phonenumber":"919764786256"}, 
      {name:"nidhi", "phonenumber":"919822458030"},
      {name:"vikrant", "phonenumber":"919987284850"},
      {name:"poojan", "phonenumber":"919405447769"},
      {name:"vivek", "phonenumber":"917887516336"},
    ];

    await sendwhatsappmessageapi({
      message:"Fix issue with accounting stock and physical stock mismatch - " + 
      " https://ssl.itpatil.com/items-report?adminuserid=6a043a73ef964e67e1c77ec0&appname=kitsters",
      receiverphonenumber:receiverphonenumber

    });
    $(".sendstatus").html(" | sending to: " + JSON.stringify(receiverphonenumber));
    setTimeout(() => {$(".sendstatus").html("")}, 2000);

  };

  const params = new URLSearchParams(window.location.search);

  useEffect(() => {
    fetchdata();
  }, []);


  return (
    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}
      <h3 style={{ marginBottom: '16px' }}>Composite Items stock mismatch | Problem Count: {compositeitemdata.length}</h3>

      <TableCompositeItem compositeitemdata={compositeitemdata} />


      <h3 style={{ marginBottom: '16px' }}>Items stock mismatch | Problem Count: {itemdata.length} </h3>
      <TableItem itemdata={itemdata} />

    </div>
  );

};

export default ItemStockCheck;
